import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
class ServiceList extends Component {
    constructor(props) {
        super();
        this.state = {
            providerId: '',
            serviceId: ''
        };
    }
    renderProviderProfile = (providerId, serviceId) => {
        this.setState({
            redirect: true,
            providerId: providerId,
            serviceId: serviceId
        });
    };
    render() {
        const { data } = this.props;
        if (this.state.providerId) {
            this.props.history.push({
                pathname: `/provider/detail/${this.state.providerId}/${this.state.serviceId}`,
                state: {
                    providerId: this.state.providerId,
                    serviceId: this.state.serviceId
                }
            });
        }
        return (
            <div className="service-modal-li">
                <div className="row align-items-center" key={data.key}>
                    <div className="col-md-7 text-left modal-list">
                        <h4>{data.heading}</h4>
                        <p>{data.description}</p>
                    </div>
                    <div className="col-md-5 text-right">
                        <Button
                            className="btn-primary-new"
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                this.renderProviderProfile(
                                    this.props.providerId,
                                    data.key
                                )
                            }
                        >
                            <FormattedMessage
                                id="service.viewdetail"
                                defaultMessage="View Detail"
                            />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(ServiceList);



// WEBPACK FOOTER //
// ./src/components/Providers/ServiceList.js